import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';

import { Box } from '@mui/material';
import { Element } from 'react-scroll';

import BundleCourseItems from './bundleCourseItems';
import BundleCourseItemHeader from './bundleCourseItems/bundleCourseItemHeader';

import Container from '@components/store/container';
import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleCourseItemsSectionProps = {
  scrollElementName: string;
  bundleDetailSeo: BundleEntity;
};

const BundleCourseItemsSection: FC<BundleCourseItemsSectionProps> = ({ scrollElementName, bundleDetailSeo }) => {
  const router = useRouter();
  const bundleIdOrIdName = router?.query?.idName as string;

  const { handleFetchBundleCourses, handleResetBundleCourses } = useBundleCourseItem();

  useEffect(() => {
    if (!bundleIdOrIdName) {
      return;
    }
    handleFetchBundleCourses(bundleIdOrIdName);
    return () => {
      handleResetBundleCourses();
    };
  }, [bundleIdOrIdName]);

  return (
    <Element name={scrollElementName}>
      <Box pt={{ xs: 5, lg: 6 }} pb={{ xs: 6, md: 8, lg: 9 }}>
        <Container
          containerSx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 0, md: '28px' },
            px: { xs: 3, md: '20px' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <BundleCourseItemHeader />
          </Box>
          <BundleCourseItems bundleDetailSeo={bundleDetailSeo} />
        </Container>
      </Box>
    </Element>
  );
};

export default BundleCourseItemsSection;
